import type { SVGProps } from "react";
const SvgIconCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M680 864H272c-26.47 0-48-21.53-48-48V280c0-13.25 10.75-24 24-24s24 10.75 24 24v536h408c13.25 0 24 10.75 24 24s-10.75 24-24 24" />
    <path d="M752 768H368c-26.47 0-48-21.53-48-48V208c0-26.47 21.53-48 48-48h384c26.47 0 48 21.53 48 48v512c0 26.47-21.53 48-48 48M368 208v512h384.03L752 208z" />
  </svg>
);
export default SvgIconCopy;
